import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { XCircle, CheckCircle2, Lock, Mail, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-[#2F4538] text-[#F5F0E8] relative overflow-hidden" data-id="element-82">
      <div className="absolute inset-0 opacity-20" data-id="element-83">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#B4A7D6] rounded-full blur-[150px]" data-id="element-84"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-86">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-8 leading-tight" data-id="element-87">
            Tenés 2 opciones hoy:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-88">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-3xl border border-white/10" data-id="element-89">
            <div className="flex items-center gap-3 mb-6" data-id="element-90">
              <XCircle className="w-8 h-8 text-red-400" data-id="element-91" />
              <h3 className="text-2xl font-bold" data-id="element-92">
                OPCIÓN 1: Seguir como hasta ahora
              </h3>
            </div>
            <p className="text-[#F5F0E8]/80 mb-6 leading-relaxed" data-id="element-93">
              Arrastrando el cansancio. Durmiendo mal. Con ansiedad constante.
              Gastando $60.000/mes en terapia. Dependiendo de turnos, horarios,
              y otras personas.
            </p>
            <div className="bg-black/20 p-4 rounded-xl border border-white/5" data-id="element-94">
              <p className="text-[#F5F0E8]/70" data-id="element-95">¿Funciona? Más o menos.</p>
              <p className="font-bold text-red-400" data-id="element-96">¿Es sostenible? No.</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="bg-[#F5F0E8] text-[#1a1a1a] p-8 rounded-3xl border-4 border-[#B4A7D6]/30 shadow-2xl transform md:-translate-y-4" data-id="element-97">
            <div className="flex items-center gap-3 mb-6" data-id="element-98">
              <CheckCircle2 className="w-8 h-8 text-[#8B9D83]" data-id="element-99" />
              <h3 className="text-2xl font-bold text-[#2F4538]" data-id="element-100">
                OPCIÓN 2: Tomar el control HOY
              </h3>
            </div>
            <p className="text-[#1a1a1a]/80 mb-6 leading-relaxed" data-id="element-101">
              Invertir $15.990 UNA VEZ. Tener un sistema completo en tus manos.
              Usarlo cuando LO NECESITES (no cuando haya turno). Sentir
              resultados en 7 días. Tener acceso de por vida.
            </p>
            <div className="bg-white p-4 rounded-xl border border-[#D4AF37]/30" data-id="element-102">
              <p className="text-[#1a1a1a]/70" data-id="element-103">¿Funciona? Sí.</p>
              <p className="font-bold text-[#8B9D83]" data-id="element-104">
                ¿Es sostenible? Absolutamente.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-105">
          <p className="text-xl sm:text-2xl text-[#D4AF37] mb-8 font-light italic" data-id="element-106">
            La decisión es tuya. Pero si hay algo que aprendí en estos años es
            que el tiempo no vuelve. Cada día que pasa sin hacer nada por tu
            bienestar es un día perdido. Hoy podés cambiar eso.
          </p>

          <a href="#oferta" className="inline-block w-full sm:w-auto bg-[#B4A7D6] text-[#F5F0E8] px-10 py-5 rounded-full font-bold text-xl hover:bg-[#9D8FC4] transition-all transform hover:scale-105 shadow-[0_10px_30px_rgba(180,167,214,0.4)] mb-8" data-id="element-107">
            SÍ, QUIERO TRANSFORMAR MI ENERGÍA AHORA →
          </a>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-[#F5F0E8]/70 text-sm font-medium" data-id="element-108">
            <span className="flex items-center gap-2" data-id="element-109">
              <span className="text-red-400 animate-pulse" data-id="element-110">⏰</span> Precio de
              lanzamiento: $15.990
            </span>
            <span className="flex items-center gap-2" data-id="element-111">
              <Lock className="w-4 h-4 text-[#D4AF37]" data-id="element-112" /> Pago seguro con
              Mercado Pago
            </span>
            <span className="flex items-center gap-2" data-id="element-113">
              <Mail className="w-4 h-4 text-[#D4AF37]" data-id="element-114" /> Acceso inmediato por
              email
            </span>
            <span className="flex items-center gap-2" data-id="element-115">
              <ShieldCheck className="w-4 h-4 text-[#D4AF37]" data-id="element-116" /> Garantía de 7
              días - Sin preguntas
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}